import React from 'react';
import { Zap, Clock, Target, MessageSquare } from 'lucide-react';

const iconMap = {
  0: Zap,
  1: Clock,
  2: Target,
  3: MessageSquare
};

const WhyMe = ({ t }) => {
  return (
    <section id="why" className="py-24 bg-slate-950">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            {t.why.title}
          </h2>
          <p className="text-xl text-slate-400 max-w-2xl mx-auto">
            {t.why.subtitle}
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 max-w-5xl mx-auto">
          {t.why.items.map((item, index) => {
            const Icon = iconMap[index];
            return (
              <div
                key={index}
                className="flex items-start space-x-6 group"
              >
                <div className="flex-shrink-0 w-16 h-16 bg-white/10 rounded-xl flex items-center justify-center group-hover:bg-white/20 transition-colors duration-300">
                  <Icon className="h-8 w-8 text-white" />
                </div>
                <div>
                  <h3 className="text-2xl font-bold text-white mb-3">
                    {item.title}
                  </h3>
                  <p className="text-slate-400 text-lg leading-relaxed">
                    {item.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyMe;
